// NODE_MODULE
import { Moment } from 'moment';

// TEMPLATE
import T_modal from '../../../tpl/modals/editPage/additionalInformation.html';

// LIBS
import Modal from '@libs/EditPageModal';

// CUSTOM_ELEMENT
import CE_Address from '@libs/customElement/Address';
import CE_AddressDelivery from '@libs/customElement/AddressDelivery';
import CE_Select2 from '@libs/customElement/Select2';
import CE_SitesFinalCustomer from '@libs/customElement/Sites-FinalCustomer';

// SERVICE
import S_C_Address from '@services/Customer/CustomerAddressService';
import S_Customer from '@services/Customer/CustomerService';
import S_Site from '@services/Site/SiteService';

import { Address, DeliveryAddress } from '@js/types/_app/address';

type AdditionalInformationData = {
	infosCustomer: {
		customer: string,
	}
	autoliquidation: boolean,
	billAddress: Address
	billDeliveryAddress: Address
	deliveryAddress: DeliveryAddress,
	deadlinePayment: {
		day: number
		type: string
		fixedDate: Moment
	}
	finalCustomer: string,
	detailsBill: string,
	comment: string,
	deliveryDate: Moment,
	entryDate: Moment,
	date: Moment,
	hasFinalCustomer: boolean,
	siteCustom: string,
	sites: Array<string>

};

class AdditionalInformation extends Modal<AdditionalInformationData> {
	constructor(data: AdditionalInformationData) {
		super(data, T_modal);
	}

	protected preInit() {
		const N_customer = this.element.querySelector('[name="infosCustomer.customer"]') as CE_Select2;

		const N_billAddress = this.element.querySelector('[name-select="billAddress.id"]') as CE_Address;
		const N_billDeliveryAddress = this.element.querySelector('[name-select="billDeliveryAddress.id"]') as CE_Address;
		const N_deliveryAddress = this.element.querySelector(CE_AddressDelivery.tagName) as CE_AddressDelivery;
		const N_sites = this.element.querySelector('[name="sites"]') as CE_Select2;

		N_customer.create(this.element, { disabled: true });

		N_billAddress.setRef({ id_customer: N_customer.selectElement!, bill: true });
		N_billAddress.create(this.element);

		N_billDeliveryAddress.setRef({ id_customer: N_customer.selectElement! });
		N_billDeliveryAddress.create(this.element);

		N_sites.setRef({ customer: N_customer.selectElement! });
		N_sites.create(this.element, { multiple: true });

		N_deliveryAddress.create(N_customer.selectElement!, this.element);

		this.selectPostinit['billAddress.id'] = N_billAddress;
		this.selectPostinit['billDeliveryAddress.id'] = N_billDeliveryAddress;
		this.selectPostinit.deliveryAddress = N_deliveryAddress;
	}

	protected async setData(data: AdditionalInformationData) {
		const res: { [key: string]: any } = {
			infosCustomer: {
				customer: await S_Customer.getInstance().getDataToSelect2ByID(data.infosCustomer.customer)
			},
			autoliquidation: data.autoliquidation,
			billAddress: {
				id: await S_C_Address.getInstance().getDataToSelect2ByID(data.billAddress.id),
				text: data.billAddress.text
			},
			billDeliveryAddress: {
				id: await S_C_Address.getInstance().getDataToSelect2ByID(data.billDeliveryAddress.id),
				text: data.billDeliveryAddress.text
			},
			deliveryAddress: {
				type: data.deliveryAddress.type,
				text: data.deliveryAddress.text,
				site: await S_Site.getInstance().getDataToSelect2ByID(data.deliveryAddress.site),
				address: await S_C_Address.getInstance().getDataToSelect2ByID(data.deliveryAddress.address),
				GPSCoordinates: data.deliveryAddress.GPSCoordinates
			},
			deadlinePayment: {
				day: data.deadlinePayment.day,
				type: data.deadlinePayment.type,
				fixedDate: data.deadlinePayment.fixedDate
			},
			finalCustomer: data.finalCustomer,
			detailsBill: data.detailsBill,
			comment: data.comment,
			deliveryDate: data.deliveryDate,
			entryDate: data.entryDate,
			date: data.date,
			hasFinalCustomer: data.hasFinalCustomer,
			siteCustom: data.siteCustom,
			sites: await this.getSites(data.sites)

		};

		this.form?.setData(res);

		const N_AddressDelivery = this.element.querySelector<CE_AddressDelivery>(CE_AddressDelivery.tagName)!;
		N_AddressDelivery.update(data.deliveryAddress.type);

		const N_finalCustomer = this.element.querySelector<CE_SitesFinalCustomer>(CE_SitesFinalCustomer.tagName)!;
		N_finalCustomer.setFinalCustomer();
		const select2 = N_finalCustomer.querySelector('ap-select2-button') as CE_Select2;
		select2.postInit();
	}

	protected async getDataForm(data: { [key: string]: any }) {
		data.infosCustomer.customer = await S_Customer.getInstance().getDataToSelect2ByID(data.infosCustomer.customer);

		data.billAddress.id = await S_C_Address.getInstance().getDataToSelect2ByID(data.billAddress.id);
		data.billDeliveryAddress.id = await S_C_Address.getInstance().getDataToSelect2ByID(data.billDeliveryAddress.id);
		data.deliveryAddress.address = data.deliveryAddress.type === 'customer' && data.deliveryAddress.address
			? await S_C_Address.getInstance().getDataToSelect2ByID(data.deliveryAddress.address)
			: undefined;
		data.deliveryAddress.site = data.deliveryAddress.type === 'site' && data.deliveryAddress.site
			? await S_Site.getInstance().getDataToSelect2ByID(data.deliveryAddress.site)
			: undefined;

		data.sites = await this.getSites(data.sites);

		return data;
	}

	private async getSites(sites: string[]): Promise<string[]> {
		const result: string[] = [];

		for (const site of sites) {
			const siteData = await S_Site.getInstance().getDataToSelect2ByID(site);

			if (siteData) {
				result.push(siteData);
			}
		}

		return result;
	}
}

export default AdditionalInformation;
